var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1279",
    "data-name": "Rectangle 1279",
    width: 24,
    height: 24,
    transform: "translate(164 181)",
    fill: "#136ad0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5760",
    "data-name": "Group 5760",
    transform: "translate(-164 -181)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5125",
    "data-name": "Path 5125",
    d: "M176,181a12.015,12.015,0,1,0,8.481,3.519A12.007,12.007,0,0,0,176,181Zm4,13h-3v3a1,1,0,0,1-2,0v-3h-3a1,1,0,0,1,0-2h3v-3a1,1,0,0,1,2,0v3h3a1,1,0,0,1,0,2Z",
    fill: "#136ad0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCourse);
export default __webpack_public_path__ + "static/media/add-course.8d4a9fd93a4aa1ed00746219174ba2aa.svg";
export { ForwardRef as ReactComponent };